// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  DASHBOARD_PUBLIC_BASE_URL: 'https://iren-massive-h2o-uat.clienti.irenlucegas.it/api',
  // DASHBOARD_PUBLIC_BASE_URL: 'http://localhost:3000/api',
  DASHBOARD_PRIVATE_BASE_URL: 'https://iren-massive-h2o-uat.clienti.irenlucegas.it/api/private',
  // DASHBOARD_PRIVATE_BASE_URL: 'http://localhost:3000/api/private'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
